<template>
  <div class="collapse-container">
    <b-collapse class="card" animation="slide" aria-id="contentIdForA11y3">
      <template #trigger="props">
        <div class="collapse-trigger" role="button" aria-controls="contentIdForA11y3" :aria-expanded="props.open">
          <p>
            {{ title }}
          </p>
          <a>
            <b-icon type="is-black" class="collapse-icon" :icon="props.open ? 'chevron-down' : 'chevron-up'" />
          </a>
        </div>
      </template>
      <slot />
    </b-collapse>
  </div>
</template>

<script>
export default {
  name: 'NewMessengerConversationDetailsItem',
  props: {
    title: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss" scoped>
$messenger-border-color: #E7E8E7;

.collapse-container {
  display: flex;
  flex-direction: column;

  &:not(:last-of-type) {
    border-bottom: 1px solid $messenger-border-color;
  }

  .collapse-trigger {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    height: 64px;
    padding: 0 16px;
    border-bottom: 1px solid $messenger-border-color;
    font-weight: 600;

    @include touch {
      font-size: 20px;
    }

    :deep(.collapse-icon)>i {
      font-size: 12px !important;
    }

    p {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  .collapse-content {
    display: block;
    padding: 16px;
  }
}
</style>
